export enum LineType {
  none = 'none',
  solid = 'solid',
  dotted = 'dotted',
}

export enum LineDistance {
  full = 'full',
  halfStart = 'halfStart',
  halfEnd = 'halfEnd',
}

export enum CircleDisplayType {
  none = 'none',
  firstOnly = 'firstOnly',
  secondOnly = 'secondOnly',
  center = 'center',
  both = 'both',
}
